import { useWSModal } from "@wingspanhq/fe-component-library";
import { ModalSelectUploadDocument } from "./ModalSelectUploadDocument";

export const useModalSelectUploadDocument = () =>
  useWSModal(ModalSelectUploadDocument, {
    title: "Upload document",
    size: "S"
  });
